var _rect, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBalance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#6F00FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.145 19.5545L15.1695 19.53C15.7103 19.6654 16.3078 19.6706 16.9191 19.516C18.1902 19.2001 19.2139 18.1764 19.5298 16.9052C19.6844 16.294 19.6792 15.6965 19.5438 15.1557L21.7767 12.9229C21.9432 12.7563 22.2237 12.7717 22.3715 12.9594L22.3715 12.9594L22.3735 12.9619C22.6209 13.2711 22.86 13.603 23.0834 13.9573C23.4151 14.4847 23.6025 15.2179 23.6118 15.973C23.6212 16.7287 23.4516 17.4572 23.1232 17.979L23.1227 17.9799C22.2154 19.43 21.0975 20.5596 19.8676 21.3237C18.6613 22.064 17.3494 22.456 16.0058 22.456C15.1443 22.456 14.305 22.2975 13.4938 21.9868C13.2418 21.8884 13.1624 21.5371 13.3687 21.3309L14.6617 20.0379L15.145 19.5545Z",
    fill: "#D9CDFF",
    stroke: "#D9CDFF",
    strokeWidth: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0067 14.112C16.3754 14.112 16.727 14.225 17.0249 14.4162L14.4229 17.0182C14.2317 16.7203 14.1188 16.3687 14.1188 16C14.1188 14.964 14.9646 14.112 16.0067 14.112Z",
    fill: "#D9CDFF",
    stroke: "#D9CDFF",
    strokeWidth: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0078 9.54401C17.5527 9.54401 19.0626 10.0651 20.4024 11.0398L18.2816 13.1606C17.6581 12.6577 16.867 12.368 16.0078 12.368C13.9943 12.368 12.3758 13.9957 12.3758 16C12.3758 16.8611 12.6725 17.6512 13.1701 18.2728L10.9885 20.4609C10.2405 19.8069 9.54767 18.9989 8.94501 18.0568C8.59479 17.5068 8.40781 16.7619 8.40781 15.996C8.40781 15.23 8.59483 14.485 8.94512 13.935C9.84449 12.5239 10.9387 11.4255 12.1451 10.6769C13.3533 9.94313 14.6657 9.54401 16.0078 9.54401Z",
    fill: "#D9CDFF",
    stroke: "#D9CDFF",
    strokeWidth: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2912 16C18.2912 17.256 17.2672 18.288 16.0032 18.288C15.9552 18.288 15.9152 18.288 15.8672 18.272L18.2752 15.864C18.2912 15.912 18.2912 15.952 18.2912 16Z",
    fill: "#D9CDFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8276 8.18403C23.5876 7.94403 23.1956 7.94403 22.9556 8.18403L8.19563 22.952C7.95562 23.192 7.95562 23.584 8.19563 23.824C8.31563 23.936 8.46762 24 8.62762 24C8.78763 24 8.93962 23.936 9.05963 23.816L23.8276 9.04803C24.0756 8.80803 24.0756 8.42403 23.8276 8.18403Z",
    fill: "#D9CDFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalance);
export default __webpack_public_path__ + "static/media/balance.868d93046bb9c32eb52b0a47f193db29.svg";
export { ForwardRef as ReactComponent };